/**
 * mtapp.columnGroup() 用の設定画面を表示する
 */
import ColumnGroupSettingUI from '../components/ColumnGroupSettingUI.svelte';
import { mount } from "svelte";

export function columnGroupSettingUI() {
    if (window.mtappVars.type !== 'content_type' || window.mtappVars.mode !== 'view') {
        return;
    }

    const targetElement = document.querySelector('div.mt-mainContent--scrollable');

    if (!targetElement) {
        console.error('Target element not found');
        return;
    }

    // 新しい div 要素を作成
    const newDiv = document.createElement('div');

    // div.mt-mainContent--scrollable に新しい div を追加
    targetElement.appendChild(newDiv);

    mount(ColumnGroupSettingUI, {
            target: newDiv,
            props: {
                mtappVars: window.mtappVars
            }
        });
}
